import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "trv_token";

const client = axios.create({ baseURL: API });
client.interceptors.request.use((cfg) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});
client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && window.location.pathname !== "/login") {
      localStorage.removeItem(TOKEN_KEY);
      window.location.href = "/login";
    }
    return Promise.reject(err);
  },
);

export default client;

export function apiError(err, fallback = "Something went wrong") {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return d.msg || String(d);
}

export function fmtMoney(n) {
  return Number(n || 0).toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 });
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" }); } catch { return iso; }
}

export function fmtDateOnly(iso) {
  if (!iso) return "—";
  try { return new Date(iso.length === 10 ? iso + "T00:00:00" : iso).toLocaleDateString("en-US", { dateStyle: "medium" }); } catch { return iso; }
}

export function authedUrl(path, params = {}) {
  const u = new URL(`${API}${path}`);
  u.searchParams.set("auth", localStorage.getItem(TOKEN_KEY) || "");
  Object.entries(params).forEach(([k, v]) => { if (v) u.searchParams.set(k, v); });
  return u.toString();
}
